<template>
    <div>
        <Loading :value="loading"></Loading>
        <!-- RACOURCIS -->
        <v-card>
            <v-card-title>
                <v-breadcrumbs icons divider="chevron_right">
                    <v-breadcrumbs-item
                            icons
                            router
                            :to="item.path"
                            v-for="item in racourcis"
                            :key="item.text"
                            :disabled="item.disabled"
                    >{{ item.text }}
                    </v-breadcrumbs-item>
                </v-breadcrumbs>
            </v-card-title>
        </v-card>
        <br/>

        <v-layout wrap>
            <v-flex xs12>
                <v-card style="width:100%" class="mb-3">
                    <v-card-text fluid grid-list-md>
                        <h3>Liste des budgets chantiers</h3>
                        <v-divider class="mb-2"></v-divider>

                        <div
                        class="grid-content"
                        style="padding:3px; margin:5px"
                        >
                        <el-row>
                            <v-container fluid grid-list-md>
                            <el-card class="box-card">
                                <v-form
                                v-model="valid"
                                ref=""
                                lazy-validation
                                id=""
                                >
                                <v-layout row>
                                    <v-flex md6>
                                    <el-select
                                        filterable
                                        clearable
                                        v-model="selectSearchChantier"
                                        placeholder="Chantier"
                                        style="width:100%"
                                    >
                                        <el-option
                                        v-for="item in listeAfficheChantier"
                                        :key="item.idChant"
                                        :label="item.libelle"
                                        :value="item.idChant"
                                        >
                                        <span style="float: left">{{
                                            item.libelle.toUpperCase()
                                        }}</span>
                                        </el-option>
                                    </el-select>
                                    </v-flex>

                                    <v-flex md1>
                                    <v-btn
                                        icons
                                        color="primary"
                                        @click="loadBudgetSeclect()"
                                        small
                                    >
                                        VALIDER
                                        <v-icon right>search</v-icon>
                                    </v-btn>
                                    </v-flex>
                                </v-layout>
                                </v-form>
                            </el-card>
                            </v-container>
                        </el-row>
                        </div>
                        



                        
                        <v-layout row>
                            <v-flex xs4>
                                <v-chip style="font-size:15px" label outline
                                        color="primary"><b>TOTAL MONTANT PROPOSE
                                    : {{ new
                                    Intl.NumberFormat().format(totalMntPropose)
                                    }} </b></v-chip>
                            </v-flex>

                            <v-flex xs4>
                                <v-chip style="font-size:15px" label outline
                                        color="primary"><b>TOTAL MONTANT VALIDE
                                    : {{ new
                                    Intl.NumberFormat().format(totalMntValide)
                                    }} </b></v-chip>
                            </v-flex>
                        </v-layout>
                        
                        <data-tables
                            border
                            :header-row-style="headerRowStyle"
                            highlight-current-row
                            :data="listeChantier"
                            :summary-method="getSummExploitBudget"
                            show-summary
                            style="width: 100%"
                            >

                            <el-table-column  align="center" sortable  prop="libelle"
                                        label="CHANTIER">
                            <template
                                    slot-scope="prop"
                            >
                                <span class="subheading black--text" > {{prop.row.libelle}}  </span>
                            </template>
                            </el-table-column>
                            <el-table-column align="center" sortable prop="mntTotalProjetPropose" label="MONTANT TOTAL PROPOSE">
                            <template
                                    slot-scope="prop4"
                            >
                                <el-tag class="subheading" type="blue">
                                    {{ new Intl.NumberFormat().format(prop4.row.mntTotalProjetPropose)}}
                                </el-tag>
                            </template>
                            </el-table-column>

                            <el-table-column  align="center" sortable  prop="mntTotalProjetValide" label="MONTANT TOTAL VALIDE">
                            <template
                                    slot-scope="prop5"
                            >
                                <el-tag class="subheading" type="success">
                                    {{ new Intl.NumberFormat().format(prop5.row.mntTotalProjetValide)}}
                                </el-tag>
                            </template>
                            </el-table-column>

                            <el-table-column
                                label="ETAT"
                                prop="etat">
                            <template slot-scope="scope">
                                <el-tag
                                        :type="scope.row.etat == 0 ? 'warning' : 'success'"
                                        disable-transitions>{{scope.row.libEtatBudget}}</el-tag>
                            </template>
                            </el-table-column>

                            <el-table-column label="Action" align="center" fixed="right">
                            <template slot-scope="scope">
                                <v-tooltip top>
                                    <v-btn
                                        v-if="scope.row.etatBudget != 3"
                                        slot="activator"
                                        @click="modalDetailChant(scope.row)"
                                        fab
                                        dark
                                        small
                                        color="blue"
                                    >
                                    <v-icon dark>list</v-icon>
                                    </v-btn>Detail du chantier
                                </v-tooltip>

                            </template>
                            </el-table-column>

                        </data-tables>

                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <!--<DetailBudgetProjet :show="showDetailChant"  :detailProjet="detChant" @close="showDetailChant = false; loadBudget()" ></DetailBudgetProjet>-->
        <DetailBudgetChant :show="showDetailChant"  :detailChant="detChant" @close="showDetailChant = false; loadBudget()" ></DetailBudgetChant>

    </div>
</template>

<script>
    import Loading from "@/components/Loading";
    import DetailBudgetChant from "@/components/chantier/DetailBudgetChant"
    export default {
        name: "BudgetChant.vue",
        components: {
            Loading,
            DetailBudgetChant
        },
        data(){
            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem("userInfo")),
                roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
                droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
                loading: false,
                racourcis: [
                    {path: "/budgetChantier", text: "Budget chantier", disabled: false}
                ],

                listeChantier: [],
                listeAfficheChantier: [],
                detChant: {},
                showDetailChant :  false,
                totalMntPropose: 0,
                totalMntValide: 0,
                totalMntMarche: 0,
                selectSearchChantier: "",
                

            }
        },
        methods: {
            modalDetailChant(itemChant){
                console.log('itemChant',itemChant)
                this.detChant = itemChant
                this.showDetailChant = true
            },

            headerRowStyle({row, rowIndex}) {
                return {"color":"black"};
            },

            loadBudget(){
                this.loading = true;
                let url = this.domaine + "compteExploit/budget/chantier";
                this.$http.get(url).then(
                    resp=>{
                        this.loading = false;
                        this.listeAfficheChantier = resp.body.budgetsChantier;
                        // this.totalMntPropose = resp.body.mntTotalBugPropose;
                        // this.totalMntValide = resp.body.mntTotalBugValide;
                        // //this.totalMntMarche = resp.body.mntTotalBugMarche;
                    },
                    error=>{
                        this.loading = false;
                        this.$message.error(
                            "Une erreur est survenue lors du chargement des budget"
                        );
                    }
                )

            },

            loadMarqueurChantier(){
                this.loading = true;
                let url = this.domaine + "compteExploit/budget/chantier";
                this.$http.get(url).then(
                    response=>{
                        this.loading = false;
                        const items = response.body.budgetsChantier;
                        for (var i = 0; i < items.length; i++){}
                    }
                )
            },

            loadBudgetSeclect(){
                this.loading = true;
                let url = this.domaine + "compteExploit/budget/chantier"+'?id='+this.selectSearchChantier;     
                    this.$http.get(url).then(resp => {
                        if (resp.body) {
                            this.loading = false;
                            this.listeChantier = resp.body.budgetsChantier;
                            this.totalMntPropose = resp.body.mntTotalBugPropose;
                            this.totalMntValide = resp.body.mntTotalBugValide;
                        }
                        });
            },


            getSummExploitBudget(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "Sous total";
                        return;
                    }

                    if (index === 3) {
                        sums[index] = "N/A";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = new Intl.NumberFormat().format(
                            values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0)
                        );
                    } else {
                        sums[index] = "N/A";
                    }
                });

                return sums;
            },
        },

        mounted()
        {
            this.loadBudget();
        }
    }



</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/projet/BudgetChantier.vue